
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { toArray as toArray_1, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { empty as empty_1, singleton as singleton_1, toArray, ofArray, length } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Table } from "../../Widgets/Table/Table.js";
import { LabelId } from "../../Shared/Shared.js";
import { Label } from "../../Shared/Category.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { inventoryTableConfiguration } from "../Common.js";
import { RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function ReportView(props) {
    let elems_5, elems_4, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4", "mb-4", "p-4"])], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#EFF6FF]", "rounded-lg", "p-4", "text-center"])], (elems = [reactElement("div", {
            className: join(" ", ["text-sm", "text-[#284CB1]", "mb-1"]),
            children: t("report.inspection_calendar_stat_total"),
        }), reactElement("div", {
            className: join(" ", ["text-2xl", "font-bold", "text-[#284CB1]"]),
            children: int32ToString(length(props.Report.Rows)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#FEFCE8]", "rounded-lg", "p-4", "text-center"])], (elems_1 = [reactElement("div", {
                className: join(" ", ["text-sm", "text-[#854E0E]", "mb-1"]),
                children: t("report.inspection_calendar_stat_upcoming"),
            }), reactElement("div", {
                className: join(" ", ["text-2xl", "font-bold", "text-[#854E0E]"]),
                children: int32ToString(props.Report.UpcomingCount),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_2;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_2 = [reactElement("div", {
                    className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
                    children: t("report.inspection_calendar_stat_overdue"),
                }), reactElement("div", {
                    className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
                    children: int32ToString(props.Report.OverdueCount),
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let elems_3;
                    return (props.Report.NeverInspectedCount > 0) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#F3F4F6]", "rounded-lg", "p-4", "text-center"])], (elems_3 = [reactElement("div", {
                        className: join(" ", ["text-sm", "text-[#4B5563]", "mb-1"]),
                        children: t("report.inspection_calendar_stat_never_inspected"),
                    }), reactElement("div", {
                        className: join(" ", ["text-2xl", "font-bold", "text-[#4B5563]"]),
                        children: int32ToString(props.Report.NeverInspectedCount),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement(Table, (TableRows = toArray(props.Report.Rows), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("status", "", t("report.inspection_calendar_status"), (row) => {
            let matchValue, matchValue_1;
            return new CellContent(3, [singleton_1(new Label(new LabelId("00000000-0000-0000-0000-000000000000"), (matchValue = row.Status, (matchValue.tag === 1) ? t("report.inspection_calendar_overdue") : ((matchValue.tag === 2) ? t("report.inspection_calendar_never_inspected") : t("report.inspection_calendar_upcoming"))), (matchValue_1 = row.Status, (matchValue_1.tag === 1) ? "#dc3545" : ((matchValue_1.tag === 2) ? "#6b7280" : "#d97706")), true, undefined))]);
        }, "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("inspectionTemplates", "", t("report.inspection_calendar_templates"), (row_1) => (new CellContent(0, [join(", ", row_1.InspectionTemplateNames)])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("nextInspectionDate", "", t("report.inspection_calendar_next_date"), (row_2) => (new CellContent(6, [row_2.NextInspectionDate])), "dateRange", "date")), delay(() => append(singleton(new ColumnDefinition$1("lastInspectionDate", "", t("report.inspection_calendar_last_date"), (row_3) => (new CellContent(6, [row_3.LastInspectionDate])), "dateRange", "date")), delay(() => {
            let array;
            return map((columnDefinition_1) => (new ColumnDefinition$1(columnDefinition_1.Id, columnDefinition_1.Group, columnDefinition_1.Header, (row_4) => columnDefinition_1.AccessorFunction(row_4.Inventory), columnDefinition_1.Filter, columnDefinition_1.ColumnType)), (array = inventoryTableConfiguration(t, props.PropertyConfigurations, props.Customer, props.Configuration), array.filter((columnDefinition) => {
                if (columnDefinition.Id !== "lastInspectionDate") {
                    return columnDefinition.Id !== "nextInspectionDate";
                }
                else {
                    return false;
                }
            })));
        })))))))))),
        Controls: empty_1(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["nextInspectionDate", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(row_5) => RouterModule_encodeParts(ofArray(["tools", row_5.Inventory.Id]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "inspection-calendar-report",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

